import { render, staticRenderFns } from "./biu-select.vue?vue&type=template&id=69604a12&"
import script from "./biu-select.vue?vue&type=script&lang=ts&"
export * from "./biu-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports